import { Card } from "react-bootstrap";
import "../../styles/InfoCard.css";

const InfoCard = ({
  number,
  title,
  subtitle,
  description,
  image,
  gradient,
  icon: Icon,
  iconVariant = "purple", // NEW (optional)
  variant = "format",
}) => {
  return (
    <Card
       className={`info-card ${variant} h-100 text-white border-0 wise-gradient-border ${
        gradient ? "gradient-card" : ""
      }`}
    >
      {image && (
        <div
          className="info-card-bg"
          style={{ backgroundImage: `url(${image})` }}
        />
      )}

      {!gradient && image && <div className="info-card-overlay" />}

      {number && (
        <span className="text-secondary info-card-badge">{number}</span>
      )}

      <Card.Body className="info-card-body">
        {Icon && (
          <div className={`info-card-icon icon-${iconVariant}`}>
            <Icon size={22} />
          </div>
        )}

        <Card.Title className="info-card-title">
          {title}
          </Card.Title>

        {subtitle && (
  <div className="info-card-subtitle">
    {subtitle}
  </div>
)}
          
          {description && (
            <Card.Text className="info-card-description">
              {description}
              </Card.Text>
            )}

      </Card.Body>
    </Card>
  );
};

export default InfoCard;
